import { render, staticRenderFns } from "./RouteChildList.vue?vue&type=template&id=6342ed4c"
import script from "./RouteChildList.vue?vue&type=script&lang=js"
export * from "./RouteChildList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports